import NotificationsWidgetPopoverComponent from './notifications-popover.component'

const NotificationsWidgetPopoverModule = angular.module('cdbl.notifications-popover', [

])
  .component('cdblNotificationsWidgetPopover', NotificationsWidgetPopoverComponent)
  .name

export default NotificationsWidgetPopoverModule
